import { SubmissionError } from 'redux-form';
import {
	COMPATIBILITIES_REQUIRED_FIELDS,
	INDIVIDUAL_ROUTE_REQUIRED_FIELDS,
	INDIVIDUAL_ROUTE_WITH_AUTOPARK_REQUIRED_FIELDS,
	REGULAR_ROUTE_REQUIRED_FIELDS,
} from './constants';
import { goToElement } from '../../utils/goToElement';

export const CheckIsRegular = values => {
	return values?.type_id === 2 || values?.type?.id === 2;
};

export const transformToValidationErrors = errors => {
	return Object.entries(errors).reduce((prev, [key, error]) => {
		if (key.includes('compatibilities') && key !== 'compatibilities') {
			const arr = key.split('.');

			if (!prev.compatibilities) {
				prev.compatibilities = {};
			}

			prev.compatibilities = {
				...prev.compatibilities,
				[arr[1]]: {
					...(prev.compatibilities[arr[1]] || {}),
					[arr[2]]: !arr[3] ? error : { error },
				},
			};
		}

		prev[key] = error;

		return prev;
	}, {});
};

const validateCompatibilities = (values, key, index, fields) => {
	fields.forEach(field => {
		if (!values?.compatibilities?.[index]?.[field]) {
			const error = { compatibilities: [] };
			error.compatibilities[index] = { [field]: 'Заполните это поле' };
			goToElement(`${key}.${field}`);
			throw new SubmissionError(error);
		}
	});
};

export const validate = values => {
	if (!values.type_id) {
		throw new SubmissionError({ type_id: 'Заполните это поле' });
	}

	const isRegular = CheckIsRegular(values);

	let requiredFields = REGULAR_ROUTE_REQUIRED_FIELDS;

	if (!isRegular) {
		requiredFields = values.is_autopark
			? INDIVIDUAL_ROUTE_WITH_AUTOPARK_REQUIRED_FIELDS
			: INDIVIDUAL_ROUTE_REQUIRED_FIELDS;
	}

	requiredFields.forEach(key => {
		if (key === 'compatibilities') {
			Object.keys(values?.compatibilities).forEach(idx => {
				validateCompatibilities(values, `compatibilities[${idx}]`, idx, COMPATIBILITIES_REQUIRED_FIELDS);
			});
		}

		if (key === 'autopark_ids') {
			if (
				values?.[key] === undefined ||
				values?.[key] === '' ||
				values?.[key] === null ||
				values?.[key].length === 0
			) {
				goToElement(key);
				throw new SubmissionError({ [key]: 'Заполните это поле' });
			}
		}

		if (values?.[key] === undefined || values?.[key] === '' || values?.[key] === null || values?.[key] === []) {
			goToElement(key);
			throw new SubmissionError({ [key]: 'Заполните это поле' });
		}
	});
};
